import { client } from "@payezy/api-client/admin/client";
import type { Problem } from "@payezy/api-client/admin";
import { Kratos } from "@payezy/auth";

export const ADMIN_API_URL: string = import.meta.env.VITE_ADMIN_API_URL ?? "http://localhost:7081";
export const STAFF_KRATOS_URL: string = import.meta.env.VITE_STAFF_KRATOS_URL ?? "http://localhost:4443";
export const kratos = new Kratos(STAFF_KRATOS_URL);

client.setConfig({ baseUrl: ADMIN_API_URL, credentials: "include" });

export function isProblem(e: unknown): e is Problem {
  return typeof e === "object" && e !== null && "code" in e && "status" in e;
}

export function problemMessage(e: unknown): string {
  if (isProblem(e)) return e.detail ?? e.title;
  if (e instanceof Error) return e.message;
  return "Something went wrong";
}

export function loginUrl(extra: Record<string, string> = {}): string {
  const qs = new URLSearchParams({ return_to: window.location.href, ...extra });
  return `/auth/login?${qs}`;
}

let redirecting = false;

/** Global handling for auth problems; returns true if handled (the page is navigating away). */
export function handleAuthProblem(e: unknown): boolean {
  if (!isProblem(e) || redirecting) return false;
  switch (e.code) {
    case "unauthorized":
      redirecting = true;
      window.location.assign(loginUrl());
      return true;
    case "mfa_required":
      redirecting = true;
      window.location.assign(loginUrl({ aal: "aal2" }));
      return true;
    case "not_staff":
    case "staff_disabled":
      redirecting = true;
      window.location.assign(`/auth/denied?code=${e.code}`);
      return true;
    default:
      return false;
  }
}

/** Privileged operations need a recent sign-in; this re-authenticates and returns here. */
export function reauthenticate() {
  window.location.assign(loginUrl({ refresh: "true", aal: "aal2" }));
}

export function isStepUp(e: unknown): boolean {
  return isProblem(e) && e.code === "step_up_required";
}
